import BaseModel from '@spa/apps/trustup-pro-base-js/models/BaseModel';
import WorksiteTaskCollection from './../collections/WorksiteTaskCollection';

export default class WorksiteTaskGroup extends BaseModel
{
    
    init(data)
    {
        super.init(data);

        this.tasks = new WorksiteTaskCollection(
            this.tasks || [],
            this
        );
    }

    destroy()
    {
        if ( this.tasks ) {
            this.tasks.destroy();
        }
        super.destroy();
    }

    static getPrefix()
    {
        return 'worksite:worksite-task-group';
    }

};